import { View, StyleSheet } from '@react-pdf/renderer';

const style = StyleSheet.create({
  pdfTableHeaderStyle: {
    width: '100%',
    height: 'auto',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
  },
});

export const PdfTableHeader: React.FC = ({ ...props }) => (
  <View style={style.pdfTableHeaderStyle}>{props.children}</View>
);
